/**
 * Author: Claude Code
 * Generation: Waiting room overlay showing player readiness status
 * Version: v3.2.43
 * Modified: 2025-10-09
 */
import { useRoomStore } from '@store/RoomStore';

export default function WaitingRoom() {
  const { showWaitingRoom, currentRoom } = useRoomStore();

  if (!showWaitingRoom || !currentRoom) return null;

  return (
    <div className={`waiting-overlay ${showWaitingRoom ? 'active' : ''}`}>
      <div className="waiting-card">
        <div className="waiting-header">
          <h2 className="waiting-title">Waiting for Players</h2>
          <p className="waiting-subtitle">
            Room #{currentRoom.id.slice(-3)} · {currentRoom.participantCount}/{currentRoom.maxParticipants} Players
          </p>
        </div>

        <div className="player-list">
          {(currentRoom.participants || []).map((participant) => (
            <div key={participant.id} className="player-item">
              <div className="player-info">
                <span className="player-icon">
                  {participant.agentConfiguration?.slimeType || '🟢'}
                </span>
                <span className="player-name">{participant.username}</span>
              </div>
              <div className="player-status">
                <span className={`status-badge ${participant.isReady ? 'ready' : 'editing'}`}>
                  {participant.isReady ? 'Ready' : 'Editing'}
                </span>
                <span className="player-timer">0:00</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
